import React from 'react'
import { Link } from 'react-router-dom'
import { startingSwing, venue, wednesdayNightSwing } from '../content/classes'
import {
  Detail,
  LocationDetail,
  NightSchedule,
  SignupCard,
  TickList,
} from '../components/Class/ClassPageParts'
import { NeilArmstrongTestimonial } from 'app/layout/Testimonial'
import { PageHeading } from 'app/layout/PageHeading'

// On this page the price is written as the whole series
const seriesPrice = `${startingSwing.classCount} Classes, ${startingSwing.pricePerClass} each`

export const StartingSwingPage = () => (
  <article>
    <PageHeading
      title='Starting Swing'
      kicker={`${startingSwing.classCount}-class series. ${startingSwing.startLine}`}
      description={startingSwing.headline}
      video='stlswing/starting-swing.mp4'
      position='50% 30%'
      size='tall'
    />

    <div className='flex flex-col max-w-6xl px-4 py-10 mx-auto sm:px-6 md:py-16 lg:grid lg:grid-cols-12 lg:gap-16'>
      <div className='order-2 mt-12 lg:mt-0 lg:order-1 lg:col-span-7'>
        <section>
          <p className='lead'>
            {startingSwing.day}, {startingSwing.time} at {venue.name}. No
            partner needed. Every class includes a 2 hour social dance as part
            of its price (normally $10).
          </p>
          <h2 className='mt-12 h2'>About the class</h2>
          <div className='mt-6 space-y-5 body'>
            {startingSwing.description.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </section>

        <section className='grid gap-10 p-6 mt-12 bg-white rounded-3xl md:grid-cols-2 md:p-8'>
          <div>
            <h2 className='h3'>What you'll learn</h2>
            <div className='mt-4 text-muted'>
              <TickList items={startingSwing.whatYouWillLearn} />
            </div>
          </div>
          <div>
            <h2 className='h3'>Prerequisites</h2>
            <ul className='mt-4 space-y-2 text-muted'>
              {startingSwing.prerequisites.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </section>

        <section className='mt-16'>
          <h2 className='h2'>Each Wednesday night</h2>
          <div className='mt-8'>
            <NightSchedule
              steps={[
                {
                  time: '7:30 PM',
                  title: 'Starting Swing class',
                  description:
                    'One hour of instruction. We rotate partners throughout the class, so you can come on your own.',
                },
                {
                  time: '8:30 PM',
                  title: wednesdayNightSwing.name,
                  description:
                    'Our weekly social dance, included with your class. Stay for none of it, some of it, or all of it, and practice what you just learned.',
                },
                {
                  time: '10:30 PM',
                  title: 'Lights out',
                  description: 'You go home, filled with happiness.',
                },
              ]}
            />
          </div>
        </section>

        <section className='mt-16'>
          <h2 className='h2'>Details</h2>
          <dl className='mt-6 border-b border-rule'>
            <Detail label='Dates'>
              <ul>
                {startingSwing.dates.map((date) => (
                  <li key={date}>
                    {date}, {startingSwing.time}
                  </li>
                ))}
              </ul>
            </Detail>
            <Detail label='Level'>
              <p className='font-bold text-ink'>{startingSwing.level}</p>
              <p>{startingSwing.levelDescription}</p>
            </Detail>
            <Detail label='Partner'>No partner required.</Detail>
            <Detail label='Dance style'>Lindy Hop</Detail>
            <Detail label='Price'>
              <p>
                {seriesPrice}, includes 2 hour social event.{' '}
                {startingSwing.studentDeal}.
              </p>
              <p>
                The social event is {wednesdayNightSwing.name}, normally $10 on
                its own.
              </p>
            </Detail>
            <LocationDetail />
          </dl>
        </section>

        <section className='p-6 mt-16 bg-white rounded-3xl md:p-8'>
          <h2 className='h3'>What comes after Starting Swing?</h2>
          <p className='mt-2 body'>
            Come back the following month at the exact same time for Continuing
            Swing. It rotates between Jumps & Kicks, Turns & Spins and Classic
            Swing.
          </p>
          <Link to='/curriculum' className='inline-block mt-3 link'>
            See how our curriculum works
          </Link>
        </section>
      </div>

      <div className='order-1 lg:order-2 lg:col-span-5'>
        <SignupCard
          heading={startingSwing.startLine}
          price={seriesPrice}
          priceNote='includes 2 hour social event'
          facts={[
            `${startingSwing.day}, ${startingSwing.time}`,
            `${venue.name}, ${venue.neighborhood}`,
            startingSwing.studentDeal,
          ]}
          href={startingSwing.signupUrl}
          buttonText='Sign up for Starting Swing'
          footnote='Sign up and payment happen on our Commuvity store.'
        />
      </div>
    </div>

    <NeilArmstrongTestimonial />
  </article>
)

export default StartingSwingPage
